import React, { useRef, useEffect, useState } from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import AOS from "aos";
import "aos/dist/aos.css";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase"; // adjust if your firebase file path differs
import { useNavigate } from "react-router-dom";
import "./blog.css";

function BlogPage() {
  const [blogPosts, setBlogPosts] = useState([]);
  const scrollRef = useRef(null);
  const navigate = useNavigate();

  // 🔹 Fetch blogs from Firestore directly (same as AdminDashboard)
  const fetchBlogs = async () => {
    try {
      const blogsRef = collection(db, "blogs");
      const snapshot = await getDocs(blogsRef);
      const blogsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      blogsData.sort((firstBlog, secondBlog) => {
        const firstTime = firstBlog.createdAt?.toMillis?.() ??
          (firstBlog.createdAt?.seconds || 0) * 1000;
        const secondTime = secondBlog.createdAt?.toMillis?.() ??
          (secondBlog.createdAt?.seconds || 0) * 1000;

        return secondTime - firstTime;
      });
      setBlogPosts(blogsData);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 300, behavior: "smooth" });
  };

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
<section id="blog" className="blogssection">
  <h2 data-aos="fade-up" className="blogstitle">Blogs</h2>
  <p data-aos="fade-up" className="blogssubtitle">
    Step into the world of body art — explore piercing styles, tips, and trends loved across the UAE.
  </p>

  <div data-aos="zoom-out" className="blogscontainer">
    <button onClick={scrollLeft} className="scroll-btn left">
      <HiChevronLeft size={24} />
    </button>

    <div ref={scrollRef} className="blogsscroll">
      {blogPosts.map((blog, index) => (
        <div key={index} className="blogscard">
          {blog.imageUrl && (
            <img src={blog.imageUrl} alt={blog.title || ""} className="blogsimage" />
          )}
          <div className="blogscontent">
            {blog.createdAt?.seconds && (
              <p className="blogsdate">
                {new Date(blog.createdAt.seconds * 1000).toLocaleDateString(
                  "en-US",
                  { day: "2-digit", month: "short", year: "numeric" }
                )}
              </p>
            )}
            <div
              className="blogstext"
              dangerouslySetInnerHTML={{ __html: blog.content }}
            />
            <button
              onClick={() =>
                navigate(`/blog/${blog.urlKey}`, { state: { data: blog } })
              }
              className="readsmore"
            >
              Read More →
            </button>
          </div>
        </div>
      ))}
    </div>

    <button onClick={scrollRight} className="scroll-btn right">
      <HiChevronRight size={24} />
    </button>
  </div>
</section>

  );
}

export default BlogPage;
